import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/login',
        name: 'login',
        meta: {title: '商户登录'},
        component: () => import('../views/login.vue')
    },
    {
        path: '/',
        name: 'main',
        component: () => import("@/layout/index.vue"),
        redirect: '/merchant/device',
        children: [
            {
                path: '/merchant/device',
                name: 'device',
                meta: {title: '商户设备管理'},
                component: () => import('../views/merchant/device/device.vue')
            },
            {
                path: '/merchant/counter',
                name: 'counter',
                meta: {title: '柜台管理'},
                component: () => import('../views/merchant/counter/counter.vue')
            },
            {
                path: '/merchant/order',
                name: 'order',
                meta: {title: '订单管理'},
                component: () => import('../views/merchant/order/order.vue')
            },
            {
                path: '/merchant/prod',
                name: 'prod',
                meta: {title: '商品管理'},
                component: () => import('../views/merchant/prod/prod.vue')
            },
            {
                path: '/merchant/printer',
                name: 'printer',
                meta: {title: '打印机管理'},
                component: () => import('../views/merchant/printer/printer.vue')
            },
            {
                path: '/merchant/integral',
                name: 'integral',
                meta: {title: '能量币管理'},
                component: () => import('../views/merchant/order/Integral.vue')
            },
            {
                path: '/merchant/energyCard',
                name: 'energyCard',
                meta: {title: '能量卡'},
                component: () => import('../views/merchant/order/energyCard.vue')
            },
            {
                path: '/merchant/deliveryPerson',
                name: 'deliveryPerson',
                meta: {title: '配送员'},
                component: () => import('../views/merchant/deliveryPerson/deliveryPerson.vue')
            },
            {
                path: '/merchant/deliveryOrder',
                name: 'deliveryOrder',
                meta: {title: '配送订单'},
                component: () => import('../views/merchant/deliveryPerson/deliveryOrder.vue')
            },
            {
                path: '/merchant/article',
                name: 'article',
                meta: {title: '文章管理'},
                component: () => import('../views/merchant/article/article.vue')
            },
            {
                path: '/merchant/dealer',
                name: 'dealer',
                meta: {title: '分销员'},
                component: () => import('../views/merchant/dealer/dealer.vue')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})
export {routes}
export default router
